import Navigation from '../components/navigation';
import NewsletterForm from '../components/newsletter-form';
import ApplicationHeader from '../components/application-header';
import Slider from '../components/slider';
import 'selectize';

export default {
  init() {
    new Navigation();
    new ApplicationHeader();

    // Init all news sliders
    document.querySelectorAll('.o-section--news .o-slider').forEach((slider) => {
      new Slider(slider, {
        grabCursor: true,
        breakpoints: {
          767: {
            slidesPerView: 1.1,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 2.2,
          },
        },
      });
    });

    // Init all partner sliders
    document.querySelectorAll('.o-section--more-partners .o-slider').forEach((slider) => {
      new Slider(slider, {
        grabCursor: true,
        slidesPerView: 4,
        breakpoints: {
          767: {
            slidesPerView: 2.1,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 3.2,
          },
        },
      });
    });

    new NewsletterForm($('#newsletter-form'));
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    let that = this;

    this.updateSliderSize();
    setInterval(function() {
      that.updateSliderSize();
    }, 1000);

    // accept third party cookies button click
    $('.accept-third-party-cookies-btn').click(function(){
      console.log('allow third party cookies and reload page');
      let name = 'agp-cookies-allow-thirdparty';
      let days = 121;
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      let expires = '; expires=' + date.toUTCString();
      document.cookie = name + '=1' + expires + '; path=/';

      // reload page
      location.reload();
    });

    $('.wp-block-cover').each(function(){
      const a = $(this).find('a').first();

      if (a) {
        const href = $(a).attr('href');

        $(this).addClass('wp-block-cover--cta');
        $(this).click(function(e){
          e.stopPropagation();
          e.preventDefault();

          if (href) {
            window.location = href;
          }
        });
      }
    });
  },
  updateSliderSize() {
    $('.o-slider').each(function() {
      let id = $(this).attr('id');

      if (id) {
        var visibleSlides = $('#' + id + ' .o-slider__slide--visible');
        var maxHeight = 0;

        $(visibleSlides).each(function() {
          let height = $(this).height();
          if (height > maxHeight) {
            maxHeight = height;
          }
        });

        if (maxHeight > 0) {
          $(this).css('height', maxHeight);
        }
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js